/**
 * Feedback Service
 *
 * Sends dedicated AI feedback submissions to the server (FeedbackEntry table),
 * distinct from incidentService.js (crash/bug reports emailed to support).
 * Requires an authenticated session.
 */

import apiClient from './apiClient';

/**
 * Submit a feedback entry.
 *
 * @param {Object} params
 * @param {string} params.category - 'ai_quality' | 'performance' | 'ui_ux' | 'features' | 'reliability' | 'other'
 * @param {string} params.comment  - User-written feedback text
 * @param {number} [params.rating] - Optional 1-5 star rating
 * @returns {Promise<{success: boolean}>}
 */
export async function submitFeedback({ category, comment, rating }) {
  try {
    await apiClient.post('/api/feedback', { category, comment, rating });
    return { success: true };
  } catch (error) {
    console.error('Failed to submit feedback:', error);
    return { success: false, error: error.message };
  }
}

const feedbackService = { submitFeedback };
export default feedbackService;
